import React from 'react';
import PropTypes from 'prop-types';

import {OEIconButton} from '../../../elements/controls/oe-button';
import {OETargetMenu, OETargetConnected} from '../../../elements/target-menu/oe-target-menu';
import OETargetMenuDef from '../../../elements/target-menu/oe-target-menu';
import OEResizeObserver from '../../../../lib/components/oe-resize-observer';
import {OEStdCapBarLayoutType, OEStdCapBarPropTypes} from './oe-std-cap-bar-model';

export default class OEStdCapBarTargetBar extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    renderTargetMenu()  {
        if(this.props.targetMenuHidden) return null;
        return this.props.targetMenuEntries ?
            <OETargetConnected
                moduleId={this.props.moduleId}
                disabled={this.props.disabled || this.props.targetMenuDisabled}
                fadeInOut={false}
                entries={this.props.targetMenuEntries}
                onToggle={this.props.onTargetMenuToggle}
                onDisabledToggle={this.props.onTargetMenuDisabledToggle}
                ref={this.props.onTargetMenuRef}
            /> :
            <OETargetMenuDef
                moduleId={this.props.moduleId}
                disabled={this.props.disabled || this.props.targetMenuDisabled}
                fadeInOut={false}
                onToggle={this.props.onTargetMenuToggle}
                onDisabledToggle={this.props.onTargetMenuDisabledToggle}
                ref={this.props.onTargetMenuRef}
            />;
    }

    render()   {
        if(this.props.empty)    {
            return <div className={'target-bar ' + this.props.className} style={this.props.style}><div className="light-bg-border spacer-flex"/></div>;
        }

        const layoutType = this.props.layoutType;
        const hasTitle = !!this.props.title;
        const hasLabel = !!this.props.label;
        const hasButton = !!this.props.button;

        // note the two OEResizeObserver elements with keys set to "target-label" & "target-menu"
        // without setting the keys the internal DOM creates only one instance for both here 
        // OEResizeObserver pattern does not work properly under this circumstances -> there is no way to tell when to send a zero size to the last OEResizeObserver listener function when the view changes according to hasLabel
        // hence we have to enforce that the virtual DOM diff algorithm does not identify both OEResizeObserver as a target for optimizing to use only one instance -> add key props

        return (
            <div
                className={'target-bar ' + this.props.className + (hasTitle ? ' has-title' : '') + (hasLabel ? ' has-label' : '') + (hasButton ? ' has-button' : '')}
                style={this.props.style}
            >

                {layoutType === OEStdCapBarLayoutType.twoRow && hasTitle ? <div className="light-bg-border spacer-flex"/> : null} {/*with out target title the target menu should be aligned to the left for two row layout*/}

                <div className="content">

                    {!(hasTitle || (!hasLabel && hasButton)) ? null :
                        <div className="target-title-container">

                            {layoutType === OEStdCapBarLayoutType.threeRow ? <div className="light-bg-border spacer-flex"/> : null}

                            <div>
                                {this.props.onTargetTitleResize ? <OEResizeObserver key="target-title" onResize={this.props.onTargetTitleResize}/> : null}

                                <span className="light-bg-border target-title">
                                    {this.props.title}
                                </span>

                                {!hasButton || hasLabel ? null :
                                    <OEIconButton
                                        {...this.props.button}
                                        className={'btn light-hover-bg-border target-bar-btn ' + (this.props.button.className ? this.props.button.className : '')}
                                        disabled={this.props.disabled || this.props.button.disabled}
                                    />
                                }
                            </div>

                            {layoutType === OEStdCapBarLayoutType.threeRow ? <div className="light-bg-border spacer-flex"/> : null}

                        </div>
                    }

                    {hasLabel ?
                        <div className="target-label-container">

                            {layoutType === OEStdCapBarLayoutType.threeRow ? <div className="light-bg-border spacer-flex"/> : null}

                            <div>
                                {this.props.onTargetLabelResize ? <OEResizeObserver key="target-label" onResize={this.props.onTargetLabelResize}/> : null}

                                <span className="light-bg-border target-label">
                                    {this.props.label}
                                </span>

                                {!this.props.button ? null :
                                    <OEIconButton
                                        {...this.props.button}
                                        className={'btn light-hover-bg-border target-bar-btn ' + (this.props.button.className ? this.props.button.className : '')}
                                        disabled={this.props.disabled || this.props.button.disabled}
                                    />
                                }
                            </div>

                            {layoutType === OEStdCapBarLayoutType.threeRow ? <div className="light-bg-border spacer-flex"/> : null}

                        </div>
                    :
                        <div className="target-menu-container">

                            {layoutType === OEStdCapBarLayoutType.threeRow ? <div className="light-bg-border spacer-flex"/> : null}

                            <div>
                                {this.props.onTargetMenuResize ? <OEResizeObserver key="target-menu" onResize={this.props.onTargetMenuResize}/> : null}
                                {this.renderTargetMenu()}
                            </div>

                            {layoutType === OEStdCapBarLayoutType.threeRow ? <div className="light-bg-border spacer-flex"/> : null}

                        </div>
                    }

                </div>

                {layoutType !== OEStdCapBarLayoutType.threeRow ? <div className="light-bg-border spacer-flex"/> : null}

            </div>
        );
    }
}

OEStdCapBarTargetBar.defaultProps = {
    className: '',
    moduleId: '',
    disabled: false,
    empty: false,
    layoutType: OEStdCapBarLayoutType.singleRow,
    targetMenuDisabled: false,
    targetMenuHidden: false
};

OEStdCapBarTargetBar.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    moduleId: PropTypes.string,
    disabled: PropTypes.bool,
    empty: PropTypes.bool,
    layoutType: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.string,
    button: OEStdCapBarPropTypes.targetBarButton,
    targetMenuEntries: OETargetMenu.propTypes.entries,
    targetMenuDisabled: PropTypes.bool,
    targetMenuHidden: PropTypes.bool,
    onTargetMenuToggle: PropTypes.func,
    onTargetMenuDisabledToggle: PropTypes.func,
    onTargetTitleResize: PropTypes.func,
    onTargetLabelResize: PropTypes.func,
    onTargetMenuResize: PropTypes.func,
    targetMenuRef: PropTypes.func
};